import { render, staticRenderFns } from "./MessagesItems.vue?vue&type=template&id=0583a79e&scoped=true"
import script from "./MessagesItems.vue?vue&type=script&lang=js"
export * from "./MessagesItems.vue?vue&type=script&lang=js"
import style0 from "./MessagesItems.vue?vue&type=style&index=0&id=0583a79e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0583a79e",
  null
  
)

export default component.exports